import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { uiTheme as t } from './theme';

export interface Metric {
  label: string;
  value: ReactNode;
}

interface MetricsStripProps {
  metrics: Metric[];
}

/**
 * Rejilla fluida en vez de un número fijo de columnas: con `auto-fit` y un
 * mínimo, la franja pasa sola de cuatro columnas a dos y a una según el ancho,
 * sin una consulta de medios por cada corte.
 */
const Strip = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
  borderTop: `1px solid ${t.color.border}`,
});

const Cell = styled.div({
  padding: '16px 26px',
  borderRight: `1px solid ${t.color.border}`,
  '&:last-of-type': { borderRight: 'none' },
  [`@media (max-width: ${t.breakpoint.sm})`]: {
    borderRight: 'none',
    borderBottom: `1px solid ${t.color.border}`,
    padding: '14px 20px',
  },
});

const Label = styled.div({
  fontFamily: t.font,
  fontSize: 10.5,
  fontWeight: 600,
  letterSpacing: '0.5px',
  textTransform: 'uppercase',
  color: t.color.muted,
});

const Value = styled.div({
  marginTop: 6,
  fontFamily: t.font,
  fontSize: 18,
  fontWeight: 700,
  color: t.color.title,
});

/**
 * Molécula: franja de métricas con etiqueta arriba y valor abajo.
 *
 * Vive aquí y no en la página porque no sabe de empleados: le sirve igual a la
 * cabecera de un curso o de una sesión.
 */
const MetricsStrip = ({ metrics }: MetricsStripProps) => {
  if (metrics.length === 0) return null;

  return (
    <Strip>
      {metrics.map(metric => (
        <Cell key={metric.label}>
          <Label>{metric.label}</Label>
          <Value>{metric.value}</Value>
        </Cell>
      ))}
    </Strip>
  );
};

export default MetricsStrip;
